import axios from "axios";
import CToast from "../Components/CToast/CToast";
import { logoutAPI } from "../Services/AuthService";
import { getRemoteValue } from "../Utils/firebase";

export const handleError = async (error: any) => {
  if (axios.isAxiosError(error)) {
    var err = error.response;
    if (error.code == "ERR_NETWORK") {
      window.history.pushState({}, "LoginPage", "/");
      CToast(error.code);
    } else if (err?.status == 401) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("user");
      localStorage.removeItem("auth-storage");
      CToast("Oturumunuz sonlandı!", "warning");
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
    } else if (err?.data?.code) {
      CToast(getRemoteValue("ERROR_CODE_" + err.data.code));
    } else if (err) {
      CToast(err?.data);
    }
  }
};

// if (Array.isArray(err?.data.errors)) {
//   for (let val of err?.data.errors) {
//     CToast(val.description);
//   }
// } else if (typeof err?.data.errors === "object") {
//   for (let e in err?.data.errors) {
//     CToast(err.data.errors[e][0]);
//   }
// } else if (err?.data) {
//   CToast(err.data.message);
// } else if (err?.status == 401) {
//   debugger;
//   CToast("Please login");
//   window.history.pushState({}, "LoginPage", "/");
// } else if (err) {
//   CToast(err?.data);
// }
